/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Banner_Description2Inputs */

const en_settings_reportingapikeys_banner_description2 = /** @type {(inputs: Settings_Reportingapikeys_Banner_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API keys are displayed only once, at generation – they cannot be retrieved afterwards. Key names are unique per user: generating a key under an existing name replaces that key immediately and re-activates it if it was deactivated. Keys grant full programmatic access to the user's reporting data – share them only via secure channels, never via plain email or chat, and rotate immediately if a key may have been exposed.`)
};

/**
* | output |
* | --- |
* | "API keys are displayed only once, at generation – they cannot be retrieved afterwards. Key names are unique per user: generating a key under an existing name..." |
*
* @param {Settings_Reportingapikeys_Banner_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_banner_description2 = /** @type {((inputs?: Settings_Reportingapikeys_Banner_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Banner_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_banner_description2(inputs)
});
export { settings_reportingapikeys_banner_description2 as "settings_reportingApiKeys_banner_description" }